
<div class="interaction-details">   
    <div class="mobile-level-1">
        <div class="header-container">
            <div class="header">
                <span class="text">Menu</span>
                <img src="assets/images/home/close.svg" alt="" class="icon"
                (click)="closeMobileMenu()"
                >
            </div>
            <div class="separator"></div>
            <div class="nsw-link-list menu-nsw-list">
                <ul>
                    <li>
                        <a routerLink="whatIsBeachwatch">
                            <span>About Beachwatch</span>                            
                        </a>
                    </li>
                    <li>
                        <a routerLink="waterMonitoring">
                            <span>Water monitoring</span>                            
                        </a>
                    </li>
                    <li>
                        <a routerLink="beachwatchPartners">
                            <span>Beachwatch partners</span>                            
                        </a>
                    </li>
                    <li>
                        <a routerLink="contactUs">
                            <span>Contact us</span>                            
                        </a>
                    </li>
                    <li>
                        <a routerLink="yourFavourites">
                            <span>Your favourites</span>                            
                        </a>
                    </li>
                </ul>
            </div>            
        </div>      
    </div>
</div>      
